"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_CHAT_INTERRUPT_TYPE = exports.EDIT_CHAT_SSE_EVENT = exports.EDIT_CHAT_OUTER_HTML_MAX_CHARS = exports.EDIT_CHAT_MESSAGE_MAX_CHARS = exports.EDIT_CHAT_MESSAGE_ROLE = exports.EDIT_CHAT_SESSION_STATUS = void 0;
exports.EDIT_CHAT_SESSION_STATUS = {
    IDLE: 'idle',
    RUNNING: 'running',
    AWAITING_APPROVAL: 'awaiting_approval',
    FAILED: 'failed',
};
exports.EDIT_CHAT_MESSAGE_ROLE = {
    USER: 'user',
    ASSISTANT: 'assistant',
    TOOL: 'tool',
    SYSTEM: 'system',
    /** Mid-turn reasoning summary streamed to the chat UI (not model history). */
    REASONING: 'reasoning',
};
/** Cap on user `content` (composer, API reject, and prompt history). */
exports.EDIT_CHAT_MESSAGE_MAX_CHARS = 8000;
/**
 * Inspect chip payload and server ingest/prompt cap for html-node outerHTML.
 * Enough to identify a node; full subtree is noise and injection surface.
 */
exports.EDIT_CHAT_OUTER_HTML_MAX_CHARS = 800;
/** Named SSE keep-alive on the edit-chat AG-UI stream. */
exports.EDIT_CHAT_SSE_EVENT = {
    PING: 'ping',
};
exports.EDIT_CHAT_INTERRUPT_TYPE = {
    APPROVE_EDIT: 'approve_edit',
};
